<template>
  <div class="ttable">
    <div class="table-header flex flex-column md:flex-row md:justify-content-between">
      <div class="flex md:justify-content-between toolbar" id="table-title">
        <div class="left flex">
          <div v-if="selectedCards.length > 0" class="align-self-end pb-2">
            <Button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-outlined p-button-warning roundeds-buttons mr-2"
              @click="goToEditMode(selectedCards[0], idTable)"
              v-if="enableEditButtons && selectedCards.length === 1 && !modal"
              id="boton-editar"
              test-id="buttonEdit"
            />
            <Button
              icon="pi pi-check"
              class="p-button-rounded p-button-outlined p-button-warning roundeds-buttons mr-2"
              @click="modalSelectItem(selectedCards[0], idTable)"
              v-if="selectedCards.length == 1 && modal"
              id="boton-editar"
              test-id="buttonEdit"
            />
            <Button
              icon="pi pi-trash"
              class="p-button-rounded p-button-outlined p-button-danger roundeds-buttons mr-2"
              @click="confirmMassDelete()"
              v-if="enableDeleteButton && !modal"
              id="boton-papelera"
              test-id="buttonDelete"
            />
          </div>
          <div>
            <TTableFilters
              ref="filtersRef"
              :apiversion="apiversion"
              :dropdown="dropdown"
              :filtersFields="filtersFields"
              :enableFilterMultiple="enableFilterMultiple"
              @search="(cleanFilters) => tableRest.getData(cleanFilters)"
              :getLimit="getLimit"
              :isLoading="loading"
            />
          </div>
        </div>
        <div class="right flex pb-2">
          <Button
            v-if="enableAddButton.enabled && !modal"
            icon="pi pi-plus"
            label="Agregar"
            class="align-self-end"
            @click="$router.push({ name: enableAddButton.name, params: enableAddButton.params })"
            id="boton-agregar"
            test-id="buttonAdd"
          />
        </div>
      </div>
    </div>
    <div class="table-container">
      <DataTable
        :value="data"
        test-id="table"
        class="template-table"
        :rows="rows"
        :resizableColumns="resizableColumns"
        :columnResizeMode="columnResizeMode"
        showGridlines
        responsiveLayout="scroll"
        dataKey="id"
        :filters="filters"
        :scrollable="true"
        style="width: 100%"
        editMode="cell"
        :loading="loading"
        @row-reorder="onRowReorder"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 30]"
        :paginator="true"
        :totalRecords="tableRest?.totalRows"
        :lazy="getLimit != undefined"
        @page="handlePageChange($event)"
        id="DTid"
      >
        <div id="double-ellipsis-icon-id" v-if="ordenableTable">
          <Column
            :rowReorder="true"
            headerStyle="width: 3rem"
            :reorderableColumn="false"
            rowReorderIcon="double-ellipsis-icon"
            test-id=""
          >
            <template #body="slotProps">
              <Button
                :draggable="true"
                rowReorderIcon="double-ellipsis-icon"
                icon="double-ellipsis-icon"
                :test-id="`drag${slotProps.data.index}`"
                :style="{
                  backgroundColor: 'transparent',
                  border: 'none',
                }"
              >
              </Button>
            </template>
          </Column>
        </div>
        <template #header> </template>
        <template #empty>
          <div v-if="err === false">
            {{ emptyMsg === null ? "No hay items para mostrar." : emptyMsg }}
          </div>
          <div v-if="err === true">
            No se ha podido cargar la tabla, por favor intente más tarde.
          </div>
        </template>
        <template #loading> Descargando, espere por favor. </template>
        <Column test-id="column-data">
          <template #body="slotProps">
            <div :test-id="'fila-checkbox-nombre' + slotProps.data.index">
              <CustomCheckbox
                :idc="'fila-checkbox-nombre' + slotProps.data.index"
                :ref="'filaCheckboxNombre' + slotProps.data.index"
                :value="slotProps.data"
                v-model="selectedRow[slotProps.data.index]"
                :disabled="selection && selectedCards[0].index !== slotProps.data.index"
                @click="clickCustomCheckbox(slotProps.data, multiSelect)"
              />
            </div>
          </template>
          <template #header> </template>
        </Column>

        <Column
          v-for="(column, index) in customColumn"
          :field="column.title"
          :header="getHeader(column.title)"
          :key="column.title"
          :headerStyle="getStyle('header', column.title)"
          :bodyStyle="getStyle('body', column.title)"
          :bodyClass="getProp('class', column.title, 'body')"
          sortable
        >
          <template #body="slotProps">
            <slot
              :name="column.title + 'Body'"
              v-bind:data="slotProps.data"
              v-bind:index="slotProps.index"
              v-if="$scopedSlots[column.title + 'Body']"
            ></slot>
            <div
              :test-id="column.title + slotProps.index"
              :id="'fila-nombre' + slotProps.index"
              :class="getClassesDivContainer(column.title, slotProps.data)"
              v-if="!$scopedSlots[column.title + 'Body']"
            >
              {{ formatData(customName[index], slotProps.data) }}
            </div>
          </template>
        </Column>
        <Column v-if="enableViewButtons">
          <template #body="slotProps">
            <div class="flex justify-content-end">
              <router-link
                :to="`/${reference}/${slotProps.data[idTable]}?view=true`"
                class="decoration__links"
              >
                <Button
                  v-tooltip.left="'Visualizar este efecto'"
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-outlined mr-2"
                />
              </router-link>
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-outlined p-button-danger roundeds-buttons mr-2"
                @click="handleDeleteItem(slotProps.data)"
                :disabled="slotProps.data.Estado === 'Precarga'"
                v-tooltip.left="'Eliminar elemento'"
                v-if="reference === 'deposito/efectos'"
                test-id="buttonDelete"
              />
            </div>
          </template>
        </Column>

        <template #paginatorstart>
          <div class="flex align-items-center" v-if="getLimit != undefined">
            <b>
              <span class="pagination">{{
                `Mostrando registros del ${tableRest?.offset} al ${
                  tableRest?.offset +
                    (getLimitByDropDown === null ? getLimit : getLimitByDropDown) >
                  tableRest?.totalRows
                    ? tableRest?.totalRows
                    : tableRest?.offset +
                      (getLimitByDropDown === null ? getLimit : getLimitByDropDown)
                } de un total de ${tableRest?.totalRows}`
              }}</span>
            </b>
          </div>
        </template>
        <template #paginatorend />
      </DataTable>
    </div>
    <div v-if="!loading" style="display: flex; align-self: flex-start">
      <FileUpload
        v-if="enableUploadFile"
        uploadLabel="Importa XLS"
        chooseLabel="Importar XLS"
        mode="basic"
        name="userfile"
        withCredentials
        :url="url + '?importCSV=1'"
        accept=".xlsx"
        :maxFileSize="2000000"
      />
      <Button
        v-if="enableDownloadFile"
        id="bottonXLS"
        label="Descargar Excel"
        @click="downloadXls()"
      />
    </div>
    <ModalTemplate
      title="Confirmación de Eliminación"
      type="confirmativo"
      message="¿Está seguro que desea eliminar los elementos seleccionados?"
      :showIcon="true"
      :dismissableMask="true"
      severity="danger"
      @confirm="onConfirmMassDelete"
      @cancel="onCancelMassDelete"
      ref="ModalMassDelete"
    />
    <ModalTemplate
      title="Confirmación de Eliminación"
      type="confirmativo"
      message="¿Está seguro que desea eliminar el elemento seleccionado?"
      :showIcon="true"
      :dismissableMask="true"
      severity="danger"
      @confirm="onConfirmDelete"
      @cancel="onCancelDelete"
      ref="ModalDelete"
    />
    <strategyComponent
      v-if="modalVisible"
      :tipo-entidad="tipoEntidad"
      :data="dataEntidad"
      @close="modalVisible = false"
      @openModalsuccess="handleOpenModalSuccess"
    />
    <ModalTemplate :showIcon="false" :closable="true" ref="modalSuccess">
      <div class="flex flex-column gap-4 w-full justify-content-center">
        <div class="w-full flex justify-content-center">
          <UserRoundCheck color="#268C2D" :size="100" />
        </div>
        <div class="w-full flex flex-column justify-content-center align-items-center">
          <h3 class="w-full text-center">{{ modalTitle }}</h3>
          <div class="w-2 mb-3 blue-line"></div>
          <div class="flex justify-content-center">
            <span class="w-9 text-center">
              {{ modalMessage }}
            </span>
          </div>
        </div>
      </div>
    </ModalTemplate>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted } from "vue";
import axios from "axios";

import { useRouterCompat } from "@/composables/useRouterCompat.js";
import ModalTemplate from "../ModalTemplate.vue";
import strategyComponent from "./StrategyComponent.vue";
import { useTableRest } from "@/components/TTable/composables/useTableRest";
import { UserRoundCheck } from "lucide-vue";
import { ttableComponents } from "@/components/TTable/composables/ttableComponents";
import { useToast } from "@/composables/index.js";
import { useRest } from "@/composables/useRest";

export default {
  name: "TemplateTable",
  components: { ModalTemplate, strategyComponent, UserRoundCheck, ...ttableComponents },

  props: {
    disableButtonEdit: { type: Boolean },
    url: { type: String },
    order: { type: String },
    getLimit: { type: Number },
    filtersFields: { type: Array },
    titles: { type: Object, default: () => ({}) },
    params: { type: Object, default: () => ({}) },
    formatDoc: { type: Function },
    styles: { type: Object, default: () => ({}) },
    apiversion: { type: String, default: "1" },
    keyShow: { type: Array },
    showLink: { type: Boolean, default: false },
    resizableColumns: { type: Boolean, default: false },
    removeLimit: { type: Boolean, default: false },
    columnResizeMode: { type: String, default: "fit" },
    idTable: { type: String },
    tableTitle: { type: String },
    reference: { type: String },
    viewReference: { type: String },
    enableEditButtons: { type: Boolean },
    enableViewButtons: { type: Boolean, default: false },
    enableDeleteButton: { type: Boolean, default: true },
    modal: { type: Boolean },
    enableGlobalSearch: { type: Boolean },
    enableSelectAllCheckbox: { type: Boolean },
    multiSelect: { type: Boolean, default: true },
    enableAddButton: { type: Object, default: () => ({}) },
    enableUploadFile: { type: Boolean, default: false },
    enableDownloadFile: { type: Boolean, default: false },
    enableFilterMultiple: { type: Boolean, default: false },
    enableRefresh: { type: Boolean, default: false },
    dropdown: { type: Object, default: () => ({}) },
    ordenable: { type: Object },
    emptyMsg: { type: String, default: null },
    classesDivContainer: { type: Object, default: () => ({}) },
  },

  emits: ["selectItem"],

  setup(props, { emit, expose }) {
    const { router } = useRouterCompat();

    // Refs al template (equivalentes a this.$refs.*)
    const filtersRef = ref(null);
    const modalSuccess = ref(null);
    const ModalDelete = ref(null);
    const ModalMassDelete = ref(null);
    const filaCheckboxNombre0 = ref(null);

    // Estado (antes en data())
    const modalTitle = ref("");
    const modalMessage = ref("");
    const modalVisible = ref(false);
    const tipoEntidad = ref("");
    const dataEntidad = ref({});
    const rows = ref(10);
    const ordenableTable = ref(false);
    const dataCopy = ref([]);
    const secFiliterValue = ref(null);
    const values = reactive({});
    const filters = reactive({});
    const itr = ref(0);
    const search = ref("");
    const selectedRow = reactive({});
    const selectedCards = ref([]);
    const showButtons = ref(true);
    const selection = ref(false);
    const cbHeader = ref(false);
    const customName = ref([]);
    const customColumn = ref([]);
    const filterMultipleSelect = ref([]);
    const filterType = ref([]);
    const dropSelect = ref(false);
    const dropValue = ref(null);
    const filtro = ref("");
    const getLimitByDropDown = ref(null);
    const itemToDelete = ref(null);
    const toast = useToast();
    const rest = useRest();

    const forbiddenEditRoutes = ref([
      {
        "parametros/tipo-diligencia/edit": [
          "ufi-denuncia-legajo-ufis-oficio",
          "ecpd5fe4-7957-11ec-816d-16c2a030bb97",
          "ufiF5fe4-7957-11ec-816d-16c2a030bb97",
          "preliminar-7957-11ec-816d-16c2a030bb98",
          "SPpD-11ec-816d-16c2a030bb97",
          "SPpO-22ec-926d-16c2a030bb97",
          "ufi-denuncia-legajo-ufis-denuncia",
          "feca5fe4-7957-11ec-816d-16c2a030bb97",
        ],
      },
    ]);

    // created()
    (function initParams() {
      for (const k of props.keyShow ?? []) props.params[k] ??= {};
      for (const k in props.titles) if (props.params[k]) props.params[k].title = props.titles[k];
      for (const k in props.styles) {
        if (k === "default") continue;
        if (props.params[k]) props.params[k].style = props.styles[k];
      }
      for (const k in props.classesDivContainer) {
        if (props.params[k]) props.params[k].classesDivContainer = props.classesDivContainer[k];
      }
      for (const k in props.params) {
        props.params[k].class ??= {};
        props.params[k].style ??= {};
        props.params[k].title ??= k;
      }
      const keys = Object.keys(props.params);
      for (const k of keys) {
        customName.value.push(k);
        customColumn.value.push({ title: k });
      }
    })();

    // useTableRest (mounted)
    const tableRest = ref({});
    onMounted(() => {
      if (window.Cypress) {
        window.TemplateTable = { getData, setPage, headerCheckbox, clickCustomCheckbox };
      }

      tableRest.value = useTableRest(
        {
          url: props.url,
          getLimit: props.getLimit,
          order: props.order,
          apiversion: props.apiversion,
          getLimitByDropDown: getLimitByDropDown.value,
          removeLimit: props.removeLimit,
          rest: rest,
        },
        { filtersRef }
      );

      tableRest.value.getData();
    });

    const data = computed(() => tableRest.value.data ?? []);
    const loading = computed(() => !!tableRest.value?.loading);

    // wrappers de refs internos
    const offset = computed(() => (tableRest.value?.offset ? tableRest.value.offset.value : 0));
    const page = computed(() => (tableRest.value?.page ? tableRest.value.page.value : 1));
    const lastfilter = computed(() =>
      tableRest.value?.lastfilter ? tableRest.value.lastfilter.value : ""
    );
    const lasturl = computed(() =>
      tableRest.value?.lasturl ? tableRest.value.lasturl.value : null
    );
    const err = computed(() => (tableRest.value?.err ? tableRest.value.err.value : true));
    const totalPages = computed(() =>
      tableRest.value?.totalPages ? tableRest.value.totalPages.value : 1
    );

    // Helpers get/set loading
    function getLoading() {
      return !!tableRest.value?.loading?.value;
    }
    function setLoading(v) {
      if (tableRest.value?.loading) tableRest.value.loading.value = !!v;
    }

    // Métodos
    function handleOpenModalSuccess(config) {
      modalMessage.value = config.message;
      modalTitle.value = config.title;
      modalSuccess.value?.open?.();
      getData();
    }

    function formatData(field, doc) {
      if (props.params[field]?.format) return props.params[field].format(doc);
      try {
        return props.formatDoc(field, doc);
      } catch (e) {
        return doc[field];
      }
    }
    /**
     * Para utilizarlo tenes que enviarle un objeto a TemplateTable llamado "ordenable" con :{
          url:"la url que va a hacer el put con el orden",
          id:"nombre del id de la tabla",
          variableOrden:"el nombre del atributo que contiene el orden"
      }
    */
    async function onRowReorder(e) {
      const url = props.ordenable?.url;
      const val = e.value;
      tableRest.value.data.value = await val;
      const dataCopyLocal = JSON.parse(JSON.stringify(tableRest.value.data.value));
      setLoading(true);
      for (let i = 0; i < dataCopyLocal.length; i++) {
        tableRest.value.data.value[i][props.ordenable.variableOrden] = `${i}`;
        await axios.put(
          `${url}/${tableRest.value.data.value[i][props.ordenable.id]}`,
          tableRest.value.data.value[i],
          { withCredentials: true }
        );
      }
      setLoading(false);
    }

    function getHeader(field) {
      return props.params[field]?.title;
    }
    function getStyle(type, field) {
      return (props.params[field]?.style ?? {})[type] || "";
    }
    function getProp(prop, field, type) {
      if (type) return (props.params[field]?.[prop]?.[type] ?? "") || "";
      return props.params[field]?.[prop];
    }
    function getClassesDivContainer(field, row) {
      const conf = props.params[field]?.classesDivContainer;
      switch (typeof conf) {
        case "function":
          return conf(row[field]);
        case "string":
          return conf;
        default:
          return "";
      }
    }

    function getTableData() {
      return selectedCards.value;
    }

    function setLoadingPublic(value) {
      setLoading(value);
    }

    function getCausaCaratula(row) {
      return row.causaCaratula ? row.causaCaratula.nombre : "";
    }
    function getDate(dateStr) {
      const d = new Date(dateStr);
      return d.toLocaleDateString();
    }
    function getItem(obj) {
      if (obj.list.length > 1) {
        return obj.list[0].doc.apellido + ", " + obj.list[0].doc.nombre;
      }
    }
    function modalSelectItem(doc, id) {
      emit("selectItem", doc[id]);
    }

    function goToEditMode(doc, id) {
      if (id === "tipoID" || id === "ModeloID" || id === "SubcategoriaID") {
        tipoEntidad.value = id;
        dataEntidad.value = doc;
        modalVisible.value = true;
        return;
      }
      if (!detectRestrictedEditIDs(props.reference, doc[id])) {
        rest?.toast_open?.({
          message: "El item seleccionado no se puede editar",
          position: "top-right",
          type: "error",
          duration: 3000,
        });
        return;
      }
      router.push(`/${props.reference}/${doc[id]}`);
    }

    function detectRestrictedEditIDs(docPath, id) {
      let allowEdit = true;
      forbiddenEditRoutes.value.forEach((route) => {
        const key = Object.keys(route)[0];
        if (key === docPath) {
          route[key].forEach((badId) => {
            if (badId === id) allowEdit = false;
          });
        }
      });
      return allowEdit;
    }

    function handleDeleteItem(doc) {
      itemToDelete.value = doc;
      ModalDelete.value?.open?.();
    }

    async function onConfirmDelete() {
      try {
        await deleteItem([itemToDelete.value], props.idTable);
        ModalDelete.value?.close?.();
        getData();
        $toast?.open?.({
          message: "Se borro correctamente el elemento de la tabla",
          position: "top-right",
          type: "success",
          duration: 3000,
        });
        itemToDelete.value = null;
      } catch (error) {
        console.error("Error al eliminar el elemento:", error);
      }
    }

    function onCancelDelete() {
      ModalDelete.value?.close?.();
      itemToDelete.value = null;
    }

    async function deleteItem(list, idField) {
      if (router.history.current.name) {
        const res = await axios.get(
          `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/permiso-tipo-usuario`,
          { withCredentials: true }
        );
        const arrayPermissionTypeUser = res.data.data;

        const existsAssigned = list.find((el) =>
          arrayPermissionTypeUser.find((p) => p.PermisousuarioID == el.PermisousuarioID)
        );
        if (existsAssigned) {
          alert(
            "No es posible Eliminar el/los Permisos seleccionados, por que se encuentran asignados a un Tipo de Usuario"
          );
          return;
        }
        await elimina(list, idField);
      } else {
        await elimina(list, idField);
      }
    }

    async function elimina(list, idField) {
      let hadError = false;
      setLoading(true);
      for (const el of list) {
        try {
          await rest?.del?.({ url: `${props.url}/${el[idField]}` });
        } catch (e) {
          hadError = true;
        }
      }
      setLoading(false);

      if (!hadError) {
        getData();
      } else {
        console.log("Ocurrio un error al eliminar alguno de los elementos");
      }
    }

    function onCellEdit(event, doc, field) {
      // Modificamos el array reactivo interno de tableRest
      tableRest.value.data.value[doc.index][field] = event.target.value;
    }

    function headerCheckbox() {
      if (!cbHeader.value) {
        // Marca todos
        filaCheckboxNombre0.value?.onClick?.();
        filaCheckboxNombre0.value?.onBlur?.();

        const newSelectedRow = {};
        selectedCards.value = [];
        for (let i = 0; i < data.value.length; i++) {
          selectedCards.value[i] = data.value[i];
          newSelectedRow[i] = true;
        }
        Object.assign(selectedRow, newSelectedRow);
      } else {
        // Desmarca todos
        selectedCards.value = [];
        for (const k of Object.keys(selectedRow)) delete selectedRow[k];
      }
    }

    function clickCustomCheckbox(item, multiSelect) {
      if (cbHeader.value) cbHeader.value = false;

      const exists = selectedCards.value.find((r) => r.index === item.index);
      if (!multiSelect) {
        selectedCards.value = [item];
        selection.value = !selection.value;
        return;
      }
      if (!exists) {
        selectedCards.value.push(item);
      } else {
        selectedCards.value = selectedCards.value.filter((r) => r.index !== item.index);
      }
    }

    function handlePageChange(event) {
      if (props.getLimit == undefined) return;
      setPage(event.page, event.rows);
    }

    function setPage(pageIdx, pageSize) {
      const currentPage = tableRest.value?.page?.value ?? tableRest.value?.page;
      if (pageIdx + 1 === currentPage && pageSize === props.getLimit && rows.value === pageSize)
        return;

      if (pageSize !== props.getLimit || rows.value !== pageSize) {
        getLimitByDropDown.value = pageSize;
        rows.value = pageSize;
      }
      setLoading(true);
      tableRest.value.offset = pageIdx * pageSize;
      tableRest.value.page = pageIdx + 1;
      tableRest.value.getData();
    }

    function confirmMassDelete() {
      ModalMassDelete.value?.open?.();
    }

    async function onConfirmMassDelete() {
      try {
        await deleteItem(selectedCards.value, props.idTable);
        selectedCards.value = [];
        ModalMassDelete.value?.close?.();
        getData();
      } catch (error) {
        console.error("Error al eliminar elementos: ", error);
      }
    }

    function onCancelMassDelete() {
      ModalMassDelete.value?.close?.();
    }

    // Helper usado por varios métodos
    function getData() {
      tableRest.value?.getData?.();
    }

    // Expose (si el padre usa ref al componente)
    expose({
      getTableData,
      getLoading,
      setLoading: setLoadingPublic,
      setPage,
      headerCheckbox,
      clickCustomCheckbox,
      handleOpenModalSuccess,
    });

    // API del setup
    return {
      // state
      modalTitle,
      modalMessage,
      modalVisible,
      tipoEntidad,
      dataEntidad,
      rows,
      ordenableTable,
      dataCopy,
      secFiliterValue,
      values,
      filters,
      itr,
      search,
      selectedRow,
      selectedCards,
      showButtons,
      selection,
      cbHeader,
      customName,
      customColumn,
      filterMultipleSelect,
      filterType,
      dropSelect,
      dropValue,
      filtro,
      getLimitByDropDown,
      itemToDelete,

      // computeds / table
      data,
      loading,
      offset,
      page,
      lastfilter,
      lasturl,
      err,
      totalPages,
      forbiddenEditRoutes,
      rest,

      // refs template
      filtersRef,
      modalSuccess,
      ModalDelete,
      ModalMassDelete,
      filaCheckboxNombre0,
      tableRest,
      toast,

      // methods
      handleOpenModalSuccess,
      formatData,
      onRowReorder,
      getHeader,
      getStyle,
      getProp,
      getClassesDivContainer,
      getTableData,
      getCausaCaratula,
      getDate,
      getItem,
      modalSelectItem,
      goToEditMode,
      detectRestrictedEditIDs,
      handleDeleteItem,
      onConfirmDelete,
      onCancelDelete,
      deleteItem,
      elimina,
      onCellEdit,
      headerCheckbox,
      clickCustomCheckbox,
      handlePageChange,
      setPage,
      confirmMassDelete,
      onConfirmMassDelete,
      onCancelMassDelete,
      getData,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .table-container  */
.siis-datatable table {
  border-spacing: 0;
  table-layout: fixed;
}

.siis-datatable th {
  text-align: left;
  padding: 1rem 1rem;
  border: 1px solid #e9ecef;
  border-width: 0 0 1px 0;
  font-weight: 600;

  cursor: default;
  color: #495057;
  background: #f8f9fa;
  background-clip: border-box;
  transition: box-shadow 0.2s;
  border-width: 1px 1px 1px 1px;
}

.siis-datatable td {
  text-align: left;
  border: 1px solid #e9ecef;
  border-width: 1px;
  padding: 1rem 1rem;

  cursor: default;
}

.siis-datatable td > div {
  /* display: block; */
  word-wrap: normal;
  white-space: normal;
  max-width: 100%;
  display: block;
  /* padding: 10px; */
}

.siis-datatable th + th,
.siis-datatable td + td {
  border-left-width: 0;
}
</style>
<style scoped>
.ttable {
  display: flex;
  flex-direction: column;
  width: calc(100% - 40px);
  padding: 10px;
}

.ttable > div > * {
  margin-left: 10px;
}

.ttable > .right {
  display: flex;
  flex-direction: row-reverse;
}

.toolbar {
  width: 100%;
}

.declaracion {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* number of lines to show */
  -webkit-box-orient: vertical;
}

.action-buttons {
  text-align: right;
}

.headerItem {
  width: 250px;
}

.mb-input {
  margin-bottom: 20px;
}

#contSpan {
  max-width: 1200px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

#filterSelec {
  display: flex;
  flex-direction: column;
}

#boton-agregar {
  margin: 0;
  display: flex;
}

#itemFilter {
  display: inline-block;
  margin: 10px;
  padding: 0;
}

#filtro-multiple {
  display: inline;
  margin-bottom: 10px;
  /* margin-left: 15px; */
}

@media (max-width: 800px) {
  .flex {
    display: flex;
    flex-wrap: wrap;
  }
}

span {
  margin: 0 15px 15px 0;
}

.pagination {
  background-color: transparent;
  border: 0 none;
  color: #6c757d;
  margin: 0.143rem;
  padding: 0 0.5rem;
}
</style>
